module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "academics-top-left.90798878.webp" + "?" + Date.now();